import { render } from "./TableElem.vue?vue&type=template&id=08c95f4c"
import script from "./TableElem.vue?vue&type=script&lang=js"
export * from "./TableElem.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__